import Collapse from '@material-ui/core/Collapse';
import React, { useState, useRef, useEffect } from 'react';
import { Link } from '@reach/router';
import addIcon from '../../sharedAssets/add.svg';
import minusIcon from '../../sharedAssets/minus.svg';
import './ArticleItem.scss';

function FaqItem(props) {
  const { category, articleList } = props;
  const [isOpen, setIsOpen] = useState(props.isOpen || false);
  const elRef = useRef(null);

  useEffect(() => {
    if (props.isOpen) {
      elRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [props.isOpen]);

  return (
    <div className="article-item">
      <div
        className="article-item__category"
        ref={elRef}
        id={category}
        key={category}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="article-item__category-header">
          <h2 className="article-item__category-label">{category}</h2>
          <span className="article-item__category-count">
            {articleList.articles.length} Article
            {articleList.articles.length > 1 ? 's' : null}
          </span>
        </div>
        <img
          alt="Expander Icon"
          className="article-item__category-icon"
          src={isOpen ? minusIcon : addIcon}
        />
      </div>
      <Collapse in={isOpen}>
        <div className="article-item__items">
          {articleList.articles.map(article => {
            return (
              <div className="article-item__item" key={article.title}>
                <Link to={article.path}>
                  <h3>{article.title}</h3>
                </Link>
              </div>
            );
          })}
        </div>
      </Collapse>
    </div>
  );
}

export default React.memo(FaqItem);
